import { FolderType, ImageType } from "@/types/productTypes";

// Add this helper function at the top level
export const getFolderImageCount = (
   folder: FolderType,
   images: ImageType[]
): number => {
   const directImages = images.filter(
      (img) => img.folderId === folder.id
   ).length;
   const childImages =
      folder.children?.reduce(
         (acc, child) => acc + getFolderImageCount(child, images),
         0
      ) || 0;
   return directImages + childImages;
};
// Add this helper function near the top of the file
export const organizeFoldersIntoTree = (
   folders: FolderType[]
): FolderType[] => {
   const folderMap = new Map<number, FolderType>();
   const rootFolders: FolderType[] = [];

   // First pass: create a map of all folders
   folders.forEach((folder) => {
      folderMap.set(folder.id, { ...folder, children: [] });
   });

   // Second pass: organize into hierarchy
   folders.forEach((folder) => {
      const currentFolder = folderMap.get(folder.id)!;
      if (folder.parentId && folderMap.has(folder.parentId)) {
         // Add to parent's children
         const parent = folderMap.get(folder.parentId)!;
         parent.children = parent.children || [];
         parent.children.push(currentFolder);
      } else {
         // No parent or parent doesn't exist, add to root
         rootFolders.push(currentFolder);
      }
   });

   return rootFolders;
};
